const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaFileTextFill0\"><g id=\"evaFileTextFill1\"><path id=\"evaFileTextFill2\" fill=\"currentColor\" d=\"m19.74 7.33l-4.44-5a1 1 0 0 0-.74-.33h-8A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V8a1 1 0 0 0-.26-.67ZM9 12h3a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2Zm6 6H9a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2Zm-.29-10a.79.79 0 0 1-.71-.85V4l3.74 4Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
